<template>
  <div
    :class="componentClass"
    :style="componentStyle"
  >
    <iframe
      :allow="allowedOptionsList"
      :allowfullscreen="allowFullScreen"
      :src="[isYouTubeCookieAllowed ? `https://www.youtube.com/embed/${videoId}` : `https://www.youtube-nocookie.com/embed/${videoId}`]"
      :title="title"
      class="aspect-ratio-object"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
  import { getAdvertisingPreferences } from 'app/store/modules/cookiePreferences'
  export default {
    name: 'YoutubeEmbed',

    props: {
      allowFullScreen: {
        type: Boolean,
        default: true
      },
      aspectRatioX: {
        type: Number,
        required: true,
        default: 16
      },
      aspectRatioY: {
        type: Number,
        required: true,
        default: 9
      },
      customStyle: {
        type: Object,
        default: () => {}
      },
      title: {
        type: String,
        required: true,
        default: null
      },
      videoId: {
        type: String,
        required: true,
        default: null
      },
      allowOptions: {
        type: Array,
        default: () => [
          { name: 'accelerometer' },
          { name: 'autoplay' },
          { name: 'clipboard-write' },
          { name: 'encrypted-media' },
          { name: 'gyroscope' },
          { name: 'picture-in-picture' },
          { name: 'web-share' }
        ]
      }
    },

    computed: {
      componentClass() {
        return [`youtube-embed aspect-ratio aspect-ratio-${this.aspectRatioX}x${this.aspectRatioY}`]
      },

      componentStyle() {
        let style = {}

        style['border-radius'] = 'var(--card-border-radius)'
        style['overflow'] = 'hidden'

        return {
          ...style,
          ...this.customStyle
        }
      },

      allowedOptionsList() {
        return this.allowOptions.map((option) => option.name).join('; ')
      },

      isYouTubeCookieAllowed() {
        return getAdvertisingPreferences()
      }
    }
  }
</script>
